import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shared footer for the public pages — marketing, /reco and the gallery.
 *
 * Content is the footer the landing page has always carried; the styling is the
 * current one. It mirrors SiteHeader deliberately: same ink-800 rule, same
 * translucent ink-950 with a blur behind it, same font-brand and the same
 * crane-500 hover, so the two ends of a page read as a pair.
 *
 * `mt-auto` is what pins it to the bottom of a short page inside a flex column
 * (/reco); in the marketing page's block layout an auto top margin computes to
 * zero, so it costs nothing there.
 */
const FOCUS = 'rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-crane-500';
const LINK = `${FOCUS} transition-colors hover:text-crane-500`;

const SiteFooter: React.FC = () => (
  <footer className="mt-auto w-full border-t border-ink-800 bg-ink-950/90 px-4 py-5 backdrop-blur-lg sm:px-6">
    <div className="mx-auto flex max-w-7xl flex-col gap-2 font-brand text-ui font-light text-ink-400 sm:flex-row sm:items-center sm:justify-between sm:gap-0">

      {/* Left (always one line) */}
      <p className="text-center leading-tight sm:text-left">
        Made with passion for those shaping the world in 3D
      </p>

      {/* Right: stacked on mobile, single line on desktop */}
      <div className="flex flex-col items-center gap-y-1 text-center leading-tight sm:flex-row sm:justify-end sm:gap-x-4 sm:gap-y-0 sm:text-right">
        <span className="flex items-center gap-1.5">
          {/* An inline glyph rather than an icon import: it is punctuation, and
              it has to sit on the text baseline at the same size as the words. */}
          <span aria-hidden>&copy;</span>
          Copyright cr3ate.ai / Ydrive Inc.
        </span>

        <div className="flex flex-wrap justify-center gap-x-3 sm:justify-end">
          <Link to="/terms" className={LINK}>Terms</Link>
          <Link to="/privacy" className={LINK}>Privacy</Link>
          <a href="mailto:info@cr3ate.ai" className={LINK}>info@cr3ate.ai</a>
        </div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
